const BRAND_LOCKED_KEY = "uaePassBrandLocked";
// Save brand before UAEPass redirect
export const saveBrandForUAEPass = () => {
  const currentBrand = localStorage.getItem("brandName") || "burjeel";
  localStorage.setItem("pendingUAEPassBrand", currentBrand);
  localStorage.setItem("isUAEPassPending", "true");
  console.log('Brand saved for UAEPass:', currentBrand);
  return currentBrand;
};

// Restore brand after UAEPass return
export const restoreBrandFromUAEPass = () => {
  const pendingBrand = localStorage.getItem("pendingUAEPassBrand");
  if (pendingBrand && pendingBrand !== "null") {
    console.log('Restoring brand from UAEPass:', pendingBrand);
    localStorage.setItem("brandName", pendingBrand);
    localStorage.setItem(BRAND_LOCKED_KEY, "true");
    return pendingBrand;
  }
  console.log('No pending brand found to restore');
  return null;
};

// App.tsx checks this before running its brand-defaulting logic
export const isBrandLocked = () => {
  return localStorage.getItem(BRAND_LOCKED_KEY) === "true";
};

// Clean up UAEPass pending flags
export const clearUAEPassPending = () => {
  localStorage.removeItem("pendingUAEPassBrand");
  localStorage.removeItem("isUAEPassPending");
  localStorage.removeItem(BRAND_LOCKED_KEY);
  console.log('Cleared UAEPass pending flags');
};

// Check if we are returning from UAEPass
export const isReturningFromUAEPass = () => {
  const url = window.location.href;
  const hasCode = url.includes("home/login?code=");
  const hasError = url.includes("error=access_denied") ||
                   url.includes("error=invalid_request") ||
                   url.includes("error=login_required") ||
                   url.includes("error=cancelledOnApp");
  return hasCode || hasError;
};

// Get current brand
export const getCurrentBrand = () => {
  return localStorage.getItem("brandName") || "burjeel";
};

// Set brand
export const setBrand = (brandName) => {
  if (brandName && brandName !== "null") {
    localStorage.setItem("brandName", brandName);
    console.log('Brand set to:', brandName);
    return true;
  }
  return false;
};

// Mock UAEPass login for testing
export const mockUAEPassLogin = () => {
  const currentBrand = getCurrentBrand();
  console.log('🎭 MOCK: Starting mock UAEPass flow with brand:', currentBrand);
  
  // Save current brand
  saveBrandForUAEPass();
  
  // Simulate redirect to UAEPass and return after 1 second
  setTimeout(() => {
    const mockCode = 'mock_auth_code_' + Date.now();
    const mockUrl = `${window.location.origin}/home/login?code=${mockCode}&mock=true&brand=${currentBrand}`;
    console.log('🎭 MOCK: Redirecting to mock return URL:', mockUrl);
    window.location.href = mockUrl;
  }, 500);
};

// Get mock button style
export const getMockButtonStyle = () => {
  return {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 9999,
    backgroundColor: '#ff5722',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 20px',
    cursor: 'pointer',
    fontWeight: 'bold',
    boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
  };
};